<template>
	<div class="d-flex flex-column vh-100">
		<div style="padding-top: 40px;" />
		<slot />
	</div>
</template>

<script>
// *****************************************************************************

export default {
	name: 'GenericInAppScreen',
}
</script>
